import GroupDetailScreen from "@/src/screens/groups/groups-detail";

export default function GroupDetailRoute() {
	return <GroupDetailScreen />;
}
